
import $ from 'jquery';

import {validEmail} from './../../general/Validation.js';
import {showError,hideError,setInputState} from './../../general/Error.js';
import {asyncValidateAll} from "../CheckoutUtil";

const Errors = {
	'EMAIL_NOT_VALID': '#email_msg1',
	'EMAIL_IS_TAKEN': '#email_msg2',
	'EMAIL_IS_FORBIDDEN': '#email_msg3',
}

class VerifyEmailClass {

	_lastInputtedMail = '';
	_lastInputIsValid = false;

	constructor( inputEl ) {
		this.inputEl = inputEl;
		this.inputRow = this.inputEl.closest( '.input_row' );

		this.inputEl.addEventListener( 'focusout', () => setTimeout( () => this.verify( ), 10 ) );
	}

	#postVerifyEmail() {
		return new Promise( ( resolve, reject ) => {
			const email = String( this.inputEl?.value ?? '' ).trim();

			if ( '' === email ) {
				return reject( [ Errors.EMAIL_NOT_VALID ] );
			}

			// Check, so we don't check again, if we already passed.
			if ( this._lastInputtedMail === email && this._lastInputIsValid ) {
				return resolve( true );
			}

			if ( ! validEmail( email ) ) {
				return reject( [ Errors.EMAIL_NOT_VALID ] );
			}

			// Reset last input fields.
			this._lastInputIsValid = false;
			this._lastInputtedMail = email;

			// Add Async Validation.
			this.inputEl.dataset.isAsyncValidating = 'true';

			fetch( '/index.php?cl=user&fnc=verifyEMail', {
				method: 'POST',
				body: new URLSearchParams( {
					'email': email,
					'ajax': 1
				} )
			} ).then( async( res ) => {
				if ( res.ok ) {
					return await res.text();
				}

				return await Promise.reject( res.text() );
			} ).then( ( data ) => {
				const response = String( data ).trim();
				if ( response !== '' ) {

					// Show Error Message.
					if ( response.indexOf( 'forgotpwd' ) >= 0 ) {
						reject( [ Errors.EMAIL_IS_TAKEN ] );
					} else if ( response.startsWith( 'forbidden' ) ) {
						reject( [ Errors.EMAIL_IS_FORBIDDEN, [ response.substring( 11 ) ] ] );
					} else {
						reject( [ Errors.EMAIL_IS_TAKEN ] );
					}
				} else {

					// Success.
					resolve( true );
				}
			} ).catch( () => {
				/* never executed */
				reject( [ Errors.EMAIL_NOT_VALID ] );
			} ).finally( () => {

				// Remove flag marking running validation.
				this.inputEl.dataset.isAsyncValidating = null;
			} );
		} )
	}

	verify = () => {
		// If the input does not exist, we don't need to check.
		// Skip this step and return true.
		if ( ! this.inputEl ) {
			return true;
		}

		// If the input is not valid, we skip this check, because it is not needed.
		if ( this.inputEl.matches( ':invalid' ) ) {
			return false;
		}

		// Show loading indicator.
		setInputState( this.inputEl, 'loading' );

		// Check E-Mail.
		return this.#postVerifyEmail()
			.then( () => {

				this._lastInputIsValid = true;
				hideError( this.inputEl );
				return true;
			} ).catch( ( [messageField, wildcardText] ) => {

				let message = false;
				if ( messageField && messageField.startsWith( '#' ) ) {

					const messageEl = document.querySelector( messageField )
					message = messageEl?.innerHTML ?? 'Ein unbekannter Fehler ist aufgetreten';
					if ( wildcardText && wildcardText.length > 0 ){
						let wcIndex = 0;
						message = message.replace( /%s/g, () => wildcardText[ wcIndex++ ] ?? '' );
					}

					const outputEl = document.getElementById( 'email_msg' );
					outputEl.innerHTML = message;
				}

				showError( this.inputEl, message );
				this._lastInputIsValid = false;
				return false;
			} );
	}

	static getInstance = ( inputEl ) => {
		inputEl.ACL_VERIFY_EMAIL ??= new VerifyEmailClass( inputEl );
		return inputEl.ACL_VERIFY_EMAIL;
	}

	static verifyEmail = ( inputEls ) => {
		const promises = Array.from( $( inputEls ) ).map( inputEl => {
			return VerifyEmailClass.getInstance( inputEl ).verify();
		} );
		return asyncValidateAll( promises );
	}
}

const initVerifyEmail = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( 'input.verifyemail' ).forEach( inputEl => {
		VerifyEmailClass.getInstance( inputEl );
	} );
}

// Init.
document.addEventListener( 'init_forms.acl', () => initVerifyEmail() );

// Export.
const verifyEmail = VerifyEmailClass.verifyEmail;
export {
	verifyEmail as default,
	initVerifyEmail,
	VerifyEmailClass
};
